import appGlobalScript from '/builds/OE-5041/desi/desi-code/stzh-components/src/global/js/script.js';
export const globalScripts = appGlobalScript;
